import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs/Observable';
import { LoadUser, UserStateModel } from '../internal/shared/user.model';
import { UserState } from '../internal/shared/user.state';

@Injectable()
export class BillingSetupGuard implements CanActivate {
  errorMessage;

  constructor(private store: Store, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return Observable.create(observer => {
      const user = this.store.selectSnapshot(UserState.user);
      if (user && !user.loading) this.checkUser(user, observer);
      else
        this.store
          .dispatch(new LoadUser())
          .subscribe(() =>
            this.checkUser(this.store.selectSnapshot(UserState.user), observer)
          );
    });
  }

  checkUser(user: UserStateModel, observer) {
    if (user.needsToChooseAccountType) {
      observer.next(false);
      observer.complete();
      this.store.dispatch(new Navigate(['/settings/account-type-selector']));
    } else if (user.unpaidLocked) {
      observer.next(false);
      observer.complete();
      this.store.dispatch(new Navigate(['/settings/billing']));
    } else if (user.needsToProvideBillingInfo) {
      observer.next(false);
      observer.complete();
      this.store.dispatch(new Navigate(['/settings/billing']));
    } else {
      observer.next(true);
      observer.complete();
    }
  }

  resetAccountType() {
    // this.functionalityService.needsToChooseAccountType = true;
    this.router.navigateByUrl('/settings/account-type-selector');
  }
}
